import { Component, Input, OnInit } from '@angular/core';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { ContainList, INotificationResponse } from '../../../models/notification';
import { ProfileService } from '../../services/profile.service';
import { NotificationService } from 'src/app/core/services/notification-service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-notification-details',
  templateUrl: './notification-details.component.html',
  styleUrls: ['./notification-details.component.scss'],
})
export class NotificationDetailsComponent implements OnInit {
  @Input() id: number;
  @Input() item: INotificationResponse;
  @Input() list: Array<INotificationResponse> = [];
  isChecked: boolean = false;
  isElementChanged: boolean = false
  notificationList: Array<any> = [];
  changeEl: boolean = true;
  changeMaster: boolean = true;
  openedOnes: Array<any> = [];
  constructor(private modalService: ModalService,
    private profileService: ProfileService,
    private loadingService: LoadingService,
    private notificationService: NotificationService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    // if (this.item.GroupPermission) {
    //   this.isChecked = this.item.GroupPermission;
    // }
    if (Array.isArray(this.notificationService.notificationPermissionItemsList) && this.notificationService.notificationPermissionItemsList.length > 0) {
      this.item = this.notificationService.notificationPermissionItemsList.find(t => t.MasterId == this.item.MasterId)
      this.isChecked = this.item.GroupPermission

    } else {
      this.notificationService.GetNotificationPermissions().subscribe(e => {
        this.notificationService.notificationPermissionItemsList = e.Data
        this.item = this.notificationService.notificationPermissionItemsList.find(t => t.MasterId == this.item.MasterId)
        this.isChecked = this.item.GroupPermission
      });
    }
  }


  goBack() {
    this.modalService.dismissByModalId(this.id, this.list, "notification");
  }
  change(ev, item: INotificationResponse) {
    if (this.isElementChanged)
      return;
    this.isElementChanged = true;
    this.notificationList = []
    item.GroupPermission = ev
    this.notificationList = [];
    this.notificationService.notificationPermissionItemsList.forEach(element => {
      if (element.MasterId === item.MasterId) {
        element.GroupPermission = item.GroupPermission;
        element.ContainList.forEach(subElement => {
          subElement.IsPermission = item.GroupPermission;
        })
      }
      this.notificationList.push(...element.ContainList.filter(t => t.IsPermission).map(t => t.SlaveId))
    });
    this.item = this.notificationService.notificationPermissionItemsList.find(t => t.MasterId == this.item.MasterId);
    let payload = {
      NotificationIds: this.notificationList
    }
    this.loadingService.showLoading()
    this.profileService.saveNotificationPermission(payload).subscribe(res => {
      this.notificationList = [];
      this.loadingService.hideLoading()
      this.isElementChanged = false
    }, err => {
      this.notificationList = [];
      this.loadingService.hideLoading()
      this.isElementChanged = false
    }, () => {
      this.notificationList = [];
      this.loadingService.hideLoading()
      this.isElementChanged = false
    })
  }
  changeElement(ev, el: ContainList) {
    if (this.isElementChanged)
      return;
    this.isElementChanged = true
    this.notificationList = [];
    el.IsPermission = ev;
    this.notificationService.notificationPermissionItemsList.forEach(element => {
      this.notificationList.push(...element.ContainList.filter(e => {
        if (e.SlaveId == el.SlaveId) {
          e = el
        }
        return e.IsPermission == true
      }).map(a => a.SlaveId))
    });
    this.item.GroupPermission = this.item.ContainList.every(t => t.IsPermission)
    this.isChecked = this.notificationService.notificationPermissionItemsList.find(t => t.MasterId === this.item.MasterId).ContainList.every(t => t.IsPermission)
    let payload = {
      NotificationIds: this.notificationList
    }
    this.loadingService.showLoading()
    this.profileService.saveNotificationPermission(payload).subscribe(res => {
      this.notificationList = [];
      this.loadingService.hideLoading()
      this.isElementChanged = false
    }, err => {
      this.notificationList = [];
      this.loadingService.hideLoading()
      this.isElementChanged = false
    }, () => {
      this.notificationList = [];
      this.loadingService.hideLoading()
      this.isElementChanged = false
    })
  }
  // changeElement(ev, el: ContainList) {
  //   if (this.changeEl) {
  //     this.changeMaster = false;
  //     console.count("changeElement")
  //     this.notificationList = [];
  //     el.IsPermission = ev.detail.checked;
  //     this.list.forEach(element => {
  //       this.notificationList.push(...element.ContainList.filter(e => {
  //         if (e.SlaveId == el.SlaveId) {
  //           e = el
  //         }
  //         return e.IsPermission == true
  //       }).map(a => a.SlaveId))
  //     });
  //     let payload = {
  //       "NotificationIds": this.notificationList
  //     }
  //     this.profileService.saveNotificationPermission(payload).subscribe(res => {
  //       if (res.IsSuccess) {
  //         this.refreshData();
  //         setTimeout(() => {
  //           this.changeMaster = true;
  //         }, 1000);
  //       }
  //     });
  //   }
  // }

  // refreshData() {
  //   this.loadingService.showLoading();
  //   this.profileService.getNotifications().subscribe(res => {
  //     this.loadingService.hideLoading();
  //     if (res.IsSuccess) {
  //       this.list = res.Data;
  //       this.item = this.list.find(e => e.MasterId == this.item.MasterId);
  //       if (this.item.GroupPermission) {
  //         this.isChecked = true;
  //       } else {
  //         this.isChecked = false;
  //       }
  //     }
  //   });
  // }

  // change(ev, item) {
  //   if (this.changeMaster) {
  //     this.changeEl = false;
  //     if (!ev.detail.checked) {
  //       item.GroupPermission = false;
  //       item.ContainList.forEach(element => {
  //         element.IsPermission = false;
  //       });
  //       // item.ContainList = item.ContainList.map(e => { e.IsPermisson = false; return e });
  //       this.notificationList = [];
  //       this.list.forEach(element => {
  //         this.notificationList.push(...element.ContainList.filter(e => { return e.IsPermission == true }).map(a => a.SlaveId))
  //       });
  //       let payload = {
  //         "NotificationIds": this.notificationList
  //       }
  //       this.profileService.saveNotificationPermission(payload).subscribe(res => {
  //         if (res.IsSuccess) {
  //           this.refreshData();
  //           setTimeout(() => {
  //             this.changeEl = true;
  //           }, 1000);
  //         }
  //       })
  //     } else {
  //       item.GroupPermission = true;
  //       // item.ContainList = item.ContainList.map(e => { e.IsPermisson = true; return e; });
  //       item.ContainList.forEach(element => {
  //         element.IsPermission = true;
  //       });
  //       this.notificationList = [];
  //       this.list.forEach(element => {
  //         this.notificationList.push(...element.ContainList.filter(e => { return e.IsPermission == true }).map(a => a.SlaveId))
  //       });
  //       let payload = {
  //         "NotificationIds": this.notificationList
  //       }
  //       this.profileService.saveNotificationPermission(payload).subscribe(res => {
  //         if (res.IsSuccess) {
  //           this.refreshData();
  //           setTimeout(() => {
  //             this.changeEl = true;
  //           }, 1000);
  //         }
  //       })
  //     }
  //   }
  // }

}
